module.exports = "https://r.nearpod.com/assets/media/image/field-trip-6e829eaaa249f3780a08ea03a5bb33db.svg";